import { cn } from '../ui/cn.js';
import { useThemeStore } from './theme.js';

/**
 * Light/Dark segmented toggle. Styled purely with theme tokens so it
 * looks correct in every theme. Drop it into any nav/header.
 */
export function ThemeToggle({ className }: { className?: string }): JSX.Element {
  const theme = useThemeStore((s) => s.theme);
  const setTheme = useThemeStore((s) => s.setTheme);

  return (
    <div
      role="group"
      aria-label="Theme"
      className={cn(
        'inline-flex items-center gap-0.5 rounded-full border border-line bg-panel-2 p-0.5',
        className,
      )}
    >
      <button
        type="button"
        aria-label="Light mode"
        aria-pressed={theme === 'light'}
        onClick={() => setTheme('light')}
        className={cn(
          'grid h-7 w-7 place-items-center rounded-full transition-colors',
          theme === 'light' ? 'bg-fg text-panel' : 'text-muted hover:text-fg',
        )}
      >
        <svg
          width="15"
          height="15"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="4" />
          <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
        </svg>
      </button>
      <button
        type="button"
        aria-label="Dark mode"
        aria-pressed={theme === 'dark'}
        onClick={() => setTheme('dark')}
        className={cn(
          'grid h-7 w-7 place-items-center rounded-full transition-colors',
          theme === 'dark' ? 'bg-fg text-panel' : 'text-muted hover:text-fg',
        )}
      >
        <svg
          width="15"
          height="15"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
        </svg>
      </button>
    </div>
  );
}
